import { render, staticRenderFns } from "./FiscalStatisticsHeader.vue?vue&type=template&id=4ccf8248&scoped=true&"
import script from "./FiscalStatisticsHeader.vue?vue&type=script&lang=js&"
export * from "./FiscalStatisticsHeader.vue?vue&type=script&lang=js&"
import style0 from "./FiscalStatisticsHeader.vue?vue&type=style&index=0&id=4ccf8248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccf8248",
  null
  
)

export default component.exports